import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default function callOrderShippingJobs(component, order_id) {
  // const rider_id = localStorage.getItem("rider_id");
  const Authorization = "bearer " + localStorage.getItem("token");
  fetch(`${API_URL}rest/V1/rider/getToBeDeliverOrderById/${order_id}`, {
    method: "GET",
    headers: { "Content-Type": "application/json", Accept, Authorization }
    // body:JSON.stringify({rider_id,trip_id,order_id})
  })
    .then(function(response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function(data) {
      console.log("callOrderShippingJobsData", data);
      if (data[0]) {
        // data[0].data.orderData.refund_amount = 0;
        // data[0].data.orderData.refund_amount = 0;
        // data[0].data.orderData.index = k;
        // data[0].data.orderData.cash_amount = 0;
        // data[0].data.orderData.card_amount = 0;
        // data[0].data.orderData.paytm_amount = 0;
        // data[0].data.orderData.sodexo_amount = 0;
        // data[0].data.orderData.amountToBe_collected_cal =
        //   data[0].data.orderData.amountToBe_collected;

        localStorage.setItem("orderData", JSON.stringify(data[0].job_order));
        component.props.actionOrderDetails(data[0].job_order);
      }
    });
}



// WEBPACK FOOTER //
// ./src/utility/api/callOrderShippingJobs.js